import { ReactElement } from 'react';

export function DescriptionRenderer(props: any): ReactElement {
  return <span>{props.children}</span>;
}
